<template>
  <div class="modal-sidebar bg-white-1 overflow-auto">
    <div
      v-for="(item, index) of sortedItems"
      :key="item.id"
      class="sidebar-item q-px-lg q-py-md cursor-pointer"
      :class="index === selectedIndex ? 'bg-primary-1 text-heading-3 text-white-1' : 'text-body-1 text-secondary-1'"
      @click="selectedIndex = index"
    >
      <template v-if="itemType === 'period'">
        {{ getPeriod(item) }}
      </template>

      <template v-else-if="itemType === 'name-period'">
        {{ item.name }}
        <div class="text-body-1" :class="index === selectedIndex ? 'text-white-1' : null">{{ getPeriod(item) }}</div>
      </template>

      <template v-else>
        {{ item.name }}
      </template>

      <template v-if="item.status">
        <br />

        <RChip style="width: fit-content;">
          {{ item.status }}
        </RChip>
      </template>
    </div>
  </div>
</template>

<script>
// Libraries
import { orderBy } from 'lodash'
// Components
import RChip from '@/ui/RChip'

export default {
  components: {
    RChip
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },

    itemType: {
      type: String,
      validator: v => ['period', 'name-period'].includes(v)
    }
  },

  data: () => ({
    selectedIndex: 0
  }),

  computed: {
    sortedItems() {
      return orderBy(this.items, 'name')
    }
  },

  watch: {
    selectedIndex: {
      immediate: true,

      handler: 'onItemSelected'
    }
  },

  methods: {
    // access from parent
    getSelectedIndex() {
      return this.selectedIndex
    },

    // access from parent
    setSelectedIndex(newIndex) {
      this.selectedIndex = newIndex
    },

    // access from parent
    onItemSelected(newIndex) {
      this.$emit('item-selected', this.sortedItems[newIndex])
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-sidebar {
  border-top: 1px solid var(--r-white-4);
  box-shadow: 5px 20px 16px rgba(163, 177, 198, 0.5);
  z-index: 1;
  transform: scaleX(-1);

  > * {
    transform: scaleX(-1);
  }
}
</style>
